import { useEffect, useState } from 'react';

export function useScrolled(threshold = 80) {
  const [scrolled, setScrolled] = useState(
    typeof window !== 'undefined' ? window.scrollY > threshold : false,
  );

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
